import { render, staticRenderFns } from "./selectAdminRegion.vue?vue&type=template&id=5f1b8ae1&scoped=true&"
import script from "./selectAdminRegion.vue?vue&type=script&lang=js&"
export * from "./selectAdminRegion.vue?vue&type=script&lang=js&"
import style0 from "./selectAdminRegion.vue?vue&type=style&index=0&id=5f1b8ae1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b8ae1",
  null
  
)

export default component.exports